import React, { useEffect, useRef, useState } from "react";
import "./BookCall.scss";

const ThankYouCard = ({ onClose }) => {
  return (
    <div className="tw-min-h-screen tw-flex tw-items-center tw-justify-center tw-p-4">
      <div className="tw-relative tw-w-full tw-max-w-md">
        {/* Main card with curved corner effect */}
        <div className="tw-relative tw-bg-gradient-to-br tw-from-[#157438] tw-to-[#157438] tw-rounded-3xl tw-shadow-2xl tw-overflow-hidden">
          
          {/* Content */}
          <div className="tw-relative tw-px-8 tw-py-12 tw-flex tw-flex-col tw-items-center tw-text-center">
            {/* Success icon with circle background */}
            <div className="tw-relative tw-mb-8">
              <div className="tw-w-32 tw-h-32 tw-bg-gradient-to-b tw-from-[#159745] tw-to-bg-[#157438] tw-rounded-full tw-flex tw-items-center tw-justify-center">
                
                  <svg 
                    className="tw-w-12 tw-h-12 tw-text-yellow-300" 
                    fill="none" 
                    stroke="currentColor" 
                    viewBox="0 0 24 24"
                  >
                    <path 
                      strokeLinecap="round" 
                      strokeLinejoin="round" 
                      strokeWidth={3} 
                      d="M5 13l4 4L19 7"
                    />
                  </svg>

              </div>
            </div>

            {/* Text content */}
            <h1 className="tw-text-4xl tw-font-bold tw-text-white tw-mb-4">
              Thank you,
            </h1>
            <p className="tw-text-emerald-50 tw-text-lg tw-mb-8 tw-max-w-xs">
              for showing your interest. We will soon get back to you!
            </p>

            {/* Button with skewed shape */}
            <button
              onClick={onClose}
              className="btn-2-white tw-relative  hover:tw-scale-105 active:tw-scale-95 tw-shadow-lg hover:tw-shadow-xl"
              // style={{
              //   clipPath: 'polygon(8% 0%, 100% 0%, 92% 100%, 0% 100%)',
              // }}
            >
              <span className="tw-relative tw-z-10">Close</span>
            </button>
          </div>
        </div>

        {/* Subtle shadow effect */}
        <div className="tw-absolute tw-inset-0 tw-bg-emerald-900 tw-opacity-20 tw-rounded-3xl tw-blur-2xl -tw-z-10 tw-transform tw-translate-y-4"></div>
      </div>
    </div>
  );
};

const BookCall = ({ isOpen, onClose, children }) => {
  const modalRef = useRef(null);
  const [isSubmitted, setIsSubmitted] = useState(false);

  useEffect(() => {
    const handleClickOutside = (e) => {
      if (modalRef.current && !modalRef.current.contains(e.target)) {
        onClose();
      }
    };

    const handleEsc = (e) => {
      if (e.key === "Escape") {
        onClose();
      }
    };

    if (isOpen) {
      document.addEventListener("mousedown", handleClickOutside);
      document.addEventListener("keydown", handleEsc);
    }

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
      document.removeEventListener("keydown", handleEsc);
    };
  }, [isOpen, onClose]);

  const handleSubmit = (e) => {
    e.preventDefault();
    // Submit form data here if needed
    setIsSubmitted(true);
  };

  const handleThankYouClose = () => {
    setIsSubmitted(false);
    onClose();
  };

  if (!isOpen) return null;

  return (
    <div className="modal-overlay">
      <div className={`modal-box ${isSubmitted ? 'modal-box--thank-you' : ''}`} ref={modalRef}>
        {!isSubmitted ? (
          <>
            <button className="modal-close" onClick={onClose}>        
              <svg width="74" height="37" viewBox="0 0 74 37" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M0 0H46.8796C50.4535 0 53.7558 1.90732 55.5416 5.00306L74 37H26.258C22.6107 37 19.2527 35.0142 17.4953 31.8182L0 0Z" fill="white"/>
                <rect x="44.1423" y="23.728" width="2" height="18" rx="1" transform="rotate(135 44.1423 23.728)" fill="#157438"/>
                <rect x="31.4146" y="25.1423" width="2" height="18" rx="1" transform="rotate(-135 31.4146 25.1423)" fill="#157438"/>
              </svg>  
            </button>       
            <div className="modal-inner container">
              <div className="row">
                <div className="col-md-6 col-12">
                  <h2>Get in touch</h2>
                  <form onSubmit={handleSubmit}>
                    <div className="tw-inline md:tw-flex gap-4">
                      <input type="text" placeholder="First Name" required />
                      <input type="text" placeholder="Last Name" required />
                    </div>
                    <div className="tw-inline md:tw-flex gap-4">
                      <input type="email" placeholder="Email Address" required />
                      <input type="tel" placeholder="Phone Number" required />
                    </div>
                    <div className="tw-inline md:tw-flex gap-4">
                      <input type="text" placeholder="Job Title" required />
                      <input type="text" placeholder="Company Name" required />
                    </div>
                    <textarea placeholder="Tell us about your project..." required />
                    <button type="submit" className="btn-2-white">Submit</button>
                  </form>
                </div>

                <div className="col-1" />
                <div className="col-md-5 col-12 d-flex align-items-center ">
                  <div>
                    <p className="tw-mb-0 tw-text-[20px]">Select an option or email us at</p>
                    <a href="mailto:Contact@fractilestud.io" className="tw-text-white hover:tw-text-yellow-400">Contact@fractilestud.io</a>
                    <br/>
                    <br/>
                    <p className="tw-text-['20px']">Contact us today to find out more about our services.</p>
                  </div>
                </div>
              </div>
            </div>
          </>
        ) : (
          <ThankYouCard onClose={handleThankYouClose} />
        )}
      </div>
    </div>
  );
};

export default BookCall;